import { CheckPatientByPhone } from 'domain/usecases/patient/check-patient-by-phone'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteCheckPatientByPhone implements CheckPatientByPhone {
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }

  check(Phone: string): Promise<CheckPatientByPhone.Model> {
    return this.patientRepository.checkPatientByPhone(Phone)
  }
}
